<template>
    <div>

        <!-- Intervenants -->
        <h1 class="label">Sous-traitance</h1>

        <div class="level">
            <b-button class="is-primary" @click="isAddModalActive = true">
                Ajouter un sous-traitants
            </b-button>
            <b-button class="is-warning" @click="deleteAllSST">
                Supprimer tous les sous-traitants
            </b-button>
        </div>

        <b-table :data="sst">
            <template>
                <b-table-column field="sst" label="Prestataire" width="300" sortable numeric
                                v-slot="props">
                    {{ props.row.sst }}
                </b-table-column>

                <b-table-column field="cost" label="Coût" sortable v-slot="props">
                    {{ props.row.cost }} € {{ProjectType === "Subvention" ? "TTC" : "HT"}}
                </b-table-column>

                <b-table-column field="devis" label="N° devis" v-slot="props">
                    {{ props.row.devis}}
                </b-table-column>

                <b-table-column field="comment" label="Commentaire" v-slot="props">
                    {{ props.row.comment || '_____________'}}
                </b-table-column>

                <b-table-column label="Editer" v-slot="props">
                    <b-button
                            type="is-warning"
                            icon-left="pen"
                            @click="openEditModalFM(props.row)"
                    ></b-button>
                </b-table-column>

                <b-table-column label="Supprimer" v-slot="props">
                    <b-button
                            type="is-danger"
                            icon-left="trash"
                            @click="deleteSST(props.row)"
                    ></b-button>
                </b-table-column>

                <!-- Footer -->
                <template slot="footer">
                    <th style="width:40px">
                        <div class="th-wrap is-numeric"> Nb. de prestataires : {{ sst.length }}</div>
                    </th>
                    <th>
                        <div class="th-wrap"> Total coût : {{ totalCost }} € {{ProjectType === "Subvention" ? "TTC" : "HT"}}</div>
                    </th>
                </template>

            </template>
        </b-table>

        <b-modal :active.sync="isEditModalActive" has-modal-card>
            <SSTEditModal
                    :uuid=this.selectedLine.uuid
                    :sst=this.selectedLine.sst
                    :cost=this.selectedLine.cost
                    :devis=this.selectedLine.devis
                    :comment=this.selectedLine.comment
                    :livraison=this.selectedLine.livraison
                    :famille=this.selectedLine.famille
                    :action=this.selectedLine.action
                    :intitule=this.selectedLine.intitule
                    :typotravaux="typotravaux"
                    @edit-sst="onEditSST"
            ></SSTEditModal>
        </b-modal>

        <b-modal :active.sync="isAddModalActive" has-modal-card>
            <SSTAddModal
                    @add-sst="onAddSST"
                    :SST="refSSTtemp"
                    :typotravaux="typotravaux"
            ></SSTAddModal>
        </b-modal>
    </div>

</template>

<script>
    import SSTEditModal from "@/components/SSTEditModal";
    import SSTAddModal from "@/components/SSTAddModal";
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: "SousTraitance",
        props: {
            ProjectType  : {
                required: true
            }
        },
        components: {SSTEditModal, SSTAddModal},
        mounted() {
            if (localStorage.getItem("sst")) {
                this.sst = JSON.parse(localStorage.getItem("sst"));
            } else {
                this.sst = [];
            }
            // Load ref
            this.$axios.get('ref/soustraitants')
                .then(function (response) {
                    this.refSSTtemp = response.data.soustraitants;
                }.bind(this))
                .catch(error => console.log(error));
            this.$axios.get('ref/typotravaux')
            .then(function (response) {
                this.typotravaux = response.data.typotravaux;
            }.bind(this))
            .catch(error => console.log(error));
        },
        computed: {
            totalCost() {
                let sum = this.sst.reduce((acc, cur) => acc + Number(cur.cost), 0);
                this.$emit('updateProjectSSTCost', sum);
                return sum
            },
        },
        methods: {
            openEditModalFM(line) {
                this.selectedLine = line;
                this.isEditModalActive = true;
            },
            onAddSST(item) {
                // Add the item to the array
                this.sst.push({
                    uuid: uuidv4(),
                    sst: item.sst,
                    cost: item.cost,
                    devis: item.devis,
                    comment: item.comment,
                    livraison: item.livraison,
                    famille: item.famille,
                    action: item.action,
                    intitule: item.intitule
                });
                // save the updated array in localstorage
                this.saveLocalStorageSST();
                this.isAddModalActive = false;
            },
            onEditSST(item) {
                const ssti = this.findSST(item);
                // Apply the updated values
                ssti.cost = item.cost;
                ssti.devis = item.devis;
                ssti.comment = item.comment;
                ssti.livraison = item.livraison
                ssti.famille = item.famille
                ssti.action = item.action
                ssti.intitule = item.intitule
                // save the updated array in localstorage
                this.saveLocalStorageSST();
                // close the modal
                this.isEditModalActive = false;
            },
            deleteSST(item) {
                this.$buefy.dialog.confirm({
                    title: `Supprimer la ligne`,
                    confirmText: "Supprimer la ligne",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de supprimer cette ligne ? Cette action ne pourra être annulée.`,
                    onConfirm: () => {
                        // find in the array and remove
                        const index = this.sst.indexOf(item);
                        this.sst.splice(index, 1);
                        // save the updated array in localstorage
                        this.saveLocalStorageSST();
                    }
                });
            },
            deleteAllSST() {
                this.$buefy.dialog.confirm({
                    title: `Supprimer tous les salariés`,
                    confirmText: "Oui, je confirme",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de vouloir supprimer l'ensemble des salariés ? Cette action ne pourra pas être annulée`,
                    onConfirm: () => {
                        this.sst = [];
                        // save the updated array in localstorage
                        this.saveLocalStorageSST();
                    }
                });
            },
            findSST(item) {
                return this.sst.find(sst => sst.uuid === item.uuid);
            },
            saveLocalStorageSST() {
                localStorage.setItem("sst", JSON.stringify(this.sst));
                this.sst = JSON.parse(localStorage.getItem("sst"));
            }
        },
        data() {
            return {
                sst: [],
                typotravaux: {},
                refSSTtemp: [],
                isEditModalActive: false,
                selectedLine: {},
                isAddModalActive: false,
            }
        },
    }
</script>

<style scoped>

</style>
